// @ts-nocheck
import { FieldValues } from 'react-hook-form';

import { User } from 'types/api/users.type';

import { clearEmptyValues } from 'helpers/clearEmptyValues';

const useUserData = (data: FieldValues, user?: User) => {
  if (data.billingAddress) {
    clearEmptyValues(data.billingAddress);
  }

  if (data.shippingAddress) {
    clearEmptyValues(data.shippingAddress);
  }

  const userData = {
    ...user,
    ...data,
    billingAddress: {
      ...data.billingAddress,
      name: data.name || user?.name,
      surname: data.surname || user?.surname,
    },
  };

  if (data?.season) {
    let seasonsMapped = [];

    if (typeof data.season === 'string') {
      seasonsMapped =
        data?.catalog && data?.catalog.length > 0
          ? data?.catalog.map((item) => ({
              season: data?.season,
              descEng: item,
            }))
          : [
              {
                season: data?.season,
              },
            ];
    }

    userData.season = [...(user && user?.season ? user?.season : []), ...seasonsMapped];
  }

  if (data?.zone) {
    userData.zone = [
      ...(user && user?.zone ? user?.zone : []),
      {
        code: data.zone,
      },
    ];
  }

  if (data?.zoneSpecial) {
    userData.zone = [
      ...(user && user?.zone ? user?.zone : []),
      {
        code: data.zone,
      },
      ...data?.zoneSpecial,
    ];
  }

  // `...data` above copies the raw `zoneSpecial` checkbox field onto userData
  // too — it's already folded into userData.zone above, so drop the
  // leftover top-level copy or the backend's whitelist validation rejects
  // the whole PUT with "property zoneSpecial should not exist".
  delete userData.zoneSpecial;

  if (userData?.zone?.length) {
    // Remove zones where code is an array
    userData.zone = userData.zone.filter((zone: any) => !Array.isArray(zone?.code));

    // remove duplicate zones
    userData.zone = userData.zone.reduce((unique, o) => {
      if (!unique.some((obj) => obj.code === o.code)) unique.push(o);
      return unique;
    }, []);
  }

  if (!data.shippingAddress) {
    userData.shippingAddress = userData?.billingAddress;
  }

  if (data.priceList && data.priceList.id == null) {
    delete userData.priceList;
  }

  if (data.userType && data.userType.id === undefined) {
    delete userData.userType;
  }

  delete userData.catalog;
  delete userData.shippingAddress?.id;

  return {
    userData,
  };
};

export { useUserData };
